import { FC, ReactNode } from 'react';

/**
 * A linha embaixo de um KPI de produção que diz qual régua ele usa. Desde 14/10/2026 o
 * produzido é um só em todas as abas de produção (Visão geral, S&OP e Por máquina): o
 * reportado nas OPs normais pela data de início, o CP0511 sem reprocesso. A Qualidade
 * mede outra coisa (a entrada do lote no CQ, por outra data) e diz isso na linha dela.
 */
const LinhaRegua: FC<{ children: ReactNode }> = ({ children }) => (
  <p className="mt-1 border-t border-theme-border pt-2 text-2xs leading-snug text-content-muted" data-testid="linha-regua">
    {children}
  </p>
);

export default LinhaRegua;
